"use client";
import { useEffect } from 'react';
function sanitizePayload(data) {
if (!data) return data;
if (typeof data === 'string') {
return data.replace(/(\+?\d{4})\d{4,}(\d{3})/g, '$1****$2');
}
if (typeof data === 'object') {
const sanitized = Array.isArray(data) ? [] : {};
for (const [key, value] of Object.entries(data)) {
if (/phone|whatsapp|tel/i.test(key) && typeof value === 'string') {
sanitized[key] = value.replace(/(\+?\d{4})\d{4,}(\d{3})/g, '$1****$2');
} else if (/email/i.test(key) && typeof value === 'string') {
sanitized[key] = value.replace(/^([^@]{2})[^@]+(@.+)$/, '$1***$2');
} else if (/password|token|secret|auth/i.test(key)) {
sanitized[key] = '***REDACTED***';
} else if (typeof value === 'object') {
sanitized[key] = sanitizePayload(value);
} else {
sanitized[key] = value;
}
}
return sanitized;
}
return data;
}
const loggedErrors = new Set();
export function logClientError(payload) {
if (typeof window === 'undefined') return;
try {
const sanitized = sanitizePayload(payload);
const errorKey = `${sanitized.type || ''}_${sanitized.message || ''}_${sanitized.source || ''}_${sanitized.src || ''}`;
if (loggedErrors.has(errorKey)) return;
loggedErrors.add(errorKey);
if (loggedErrors.size > 100) {
loggedErrors.clear();
}
const body = JSON.stringify({
...sanitized,
url: window.location.href,
timestamp: new Date().toISOString()
});
if (navigator.sendBeacon) {
navigator.sendBeacon('/api/log-error', body);
} else {
fetch('/api/log-error', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body,
keepalive: true
}).catch(() => {});
}
} catch (e) {
}
}
export default function ErrorTracker() {
useEffect(() => {
if (typeof window === 'undefined') return;
const handleError = (event) => {
if (event.target && event.target.tagName === 'IMG') {
const src = event.target.currentSrc || event.target.src;
logClientError({
type: 'BROKEN_IMAGE_404',
source: 'DOM <img />',
message: `Image failed to load: ${src}`,
src
});
return;
}
if (event.target && event.target.tagName === 'VIDEO') {
const src = event.target.currentSrc || event.target.src;
logClientError({
type: 'BROKEN_VIDEO_404',
source: 'DOM <video />',
message: `Video failed to load: ${src}`,
src
});
return;
}
if (event.error || event.message) {
logClientError({
type: 'UNCAUGHT_JS_ERROR',
source: `${event.filename || 'unknown'}:${event.lineno || 0}`,
message: event.message || event.error?.message || 'Uncaught Error',
stack: event.error?.stack
});
}
};
const handleUnhandledRejection = (event) => {
const reason = event.reason;
logClientError({
type: 'UNHANDLED_PROMISE_REJECTION',
source: 'Promise',
message: typeof reason === 'string' ? reason : (reason?.message || 'Promise rejected'),
stack: reason?.stack
});
};
window.addEventListener('error', handleError, true);
window.addEventListener('unhandledrejection', handleUnhandledRejection);
return () => {
window.removeEventListener('error', handleError, true);
window.removeEventListener('unhandledrejection', handleUnhandledRejection);
};
}, []);
return null;
}